module.exports = __webpack_public_path__ + "static/media/report-line.abb6026c.svg";